import { ApplicationConfig, Injector, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { GraphqlConfigService } from '@zen/core/services/graphql-config.service';
import { GraphqlClientService } from '@zen/core/services/graphql-client.service';
import { studioInterceptor } from './studio.interceptor';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withFetch()),
    { provide: 'environment', useValue: environment },
    {
      provide: APOLLO_OPTIONS,
      useFactory: (graphqlConfigService: GraphqlConfigService, injector: Injector) => {
        // Environment is fully initialized before this runs 
        const storeFrontInterceptor = injector.get(studioInterceptor);
        const graphqlUri = environment.graphqlUri || environment.zbbundleUri;
        return graphqlConfigService.createApollo(storeFrontInterceptor, graphqlUri);
      },
      // deps: [EnvService, GraphqlConfigService, StorageService],
      deps: [GraphqlConfigService, Injector],
    },
    // provideAppInitializer(() => {
    //   console.log('Waiting for token before app initializes...');
    //   return waitForTokenViaPostMessage();
    // }),
    Apollo,
    GraphqlClientService,
  ],
};

// function waitForTokenViaPostMessage(): Promise<void> {
//   return new Promise((resolve) => {
//       if (environment.app == 'local') {
//         resolve();
//       }
//       if (window.opener) {
//         window.opener.postMessage('requestToken', environment.zenbasketUrl);
//       }

//       const handler = (event: MessageEvent) => {
//         if (event.origin !== environment.zenbasketUrl) return;
//         const receivedToken = event.data.token;
//         if (receivedToken) {
//           localStorage.setItem('jwt_token', receivedToken);
//           window.removeEventListener('message', handler);
//           resolve();
//         }
//       };
//       window.addEventListener('message', handler);
//   });
// }
